import styled from "styled-components";

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  background: white;
  padding: 40px 20px;
  border-radius: 8px;
  text-align: center;
  width: 60%;
  max-width: 500px;
`;

const ErrorIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #ff5641;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 50px;
  color: white;
  font-weight: bold;
`;

const Title = styled.h5`
  color: #ff5641;
  font-weight: 700;
  font-size: 20px;
  margin: 0;
`;

const Message = styled.p`
  margin: 0;
  width: 90%;
  color: #333;
  font-size: 16px;
  line-height: 1.5;
`;

const CloseButton = styled.button`
  background-color: #ff5641;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  padding: 10px;
  border: none;
  border-radius: 50px / 40px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #e64a36;
  }
`;

interface ErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

export default function ErrorDialog({ isOpen, onClose, message }: ErrorDialogProps) {
  if (!isOpen) return null;

  return (
    <DialogOverlay onClick={onClose}>
      <DialogContainer onClick={(e) => e.stopPropagation()}>
        <ErrorIcon>✕</ErrorIcon>
        <Title>Erro ao cadastrar</Title>
        <Message>{message}</Message>
        <CloseButton onClick={onClose}>Fechar</CloseButton>
      </DialogContainer>
    </DialogOverlay>
  );
}
